import {
  OnChangeFn,
  PaginationState,
  SortingState,
} from "@tanstack/react-table"
import { useState } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { CustomTable } from "~/components/table/CustomTable"

import { useColumns } from "./columns"

type Props = {
  standardsList: AdminResponses.StandardsList[]
  certificateTypes: AdminResponses.CertificateType[]
  pageCount: number
  pagination: { pageIndex: number; pageSize: number }
  totalCertificateTypes: number
  setPagination: OnChangeFn<PaginationState>
}
export function CertificatesTable({
  standardsList,
  certificateTypes,
  totalCertificateTypes,
  pageCount,
  pagination,
  setPagination,
}: Props) {
  const [sorting, setSorting] = useState<SortingState>([
    { id: "name", desc: false },
  ])

  const columns = useColumns(standardsList)
  const table = useCustomReactTable({
    data: certificateTypes,
    initialColumnPinning: { left: ["name"] },
    columns,
    state: {
      sorting,
      pagination,
    },
    pageCount,
    manualPagination: true,
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
  })
  return (
    <CustomTable
      table={table}
      pagination={true}
      manualPaginationCount={totalCertificateTypes || 0}
    />
  )
}
